let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2cXV5")).then(() => parcelRequire('1JN6i'));